import axios from 'axios'

const api = axios.create({
    baseURL: 'https://nodedeploy.veigadiniz.com.br/contracheque/',
})

export default api;

// const response = await api.post('local', data);